import { axiosRequest } from '@/util/axios-request';

// 注册
export var registerApi = function registerApi(data) {
  return axiosRequest({
    url: '/auth/web/register',
    errorMessage: true,
    data: data
  });
};
// 获取注册短信验证码
export var getRegisterShortCode = function getRegisterShortCode(data) {
  return axiosRequest({
    url: '/auth/app/smsCaptcha',
    errorMessage: true,
    data: data
  });
};

// 登录
export var login = function login(data) {
  return axiosRequest({
    url: '/auth/web/login',
    errorMessage: true,
    data: data
  });
};

// 创建公司
export var companyNew = function companyNew(data) {
  return axiosRequest({
    url: '/web/company/new',
    errorMessage: true,
    data: data
  });
};

// 获取二维码
export var getQrCode = function getQrCode(data) {
  return axiosRequest({
    url: '/auth/qr/code',
    errorMessage: true,
    method: 'GET',
    params: data
  });
};

// 二维码扫码状态查询
export var QrStatus = function QrStatus(data) {
  return axiosRequest({
    url: '/auth/qr/status',
    errorMessage: true,
    data: data
  });
};

// 公司登录
export var companyLogin = function companyLogin(data) {
  return axiosRequest({
    url: '/web/company/signin',
    errorMessage: true,
    data: data
  });
};

// 获取个人信息
export var getUserInfo = function getUserInfo(data) {
  return axiosRequest({
    url: '/auth/user/info',
    data: data
  });
};

// 公司信息
export var companyinfo = function companyinfo(data) {
  return axiosRequest({
    url: '/web/company/info',
    data: data
  });
};

// 国家
export var countries = function countries(data) {
  return axiosRequest({
    url: '/web/company/countries',
    data: data
  });
};
// 行业
export var companyIndustries = function companyIndustries(data) {
  return axiosRequest({
    url: '/web/company/industries',
    data: data
  });
};

// 规模
export var companySize = function companySize(data) {
  return axiosRequest({
    url: '/web/company/size',
    data: data
  });
};